import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';

globalThis.bootstrap = {
    Collapse,
    Dropdown
};
